/**
 * @Author: fannie
 * @Date:   2018-03-01T10:48:06+08:00
 * @Last modified by:   fannie
 * @Last modified time: 2018-03-01T10:00:09+08:00
 */

import _util from '../../utils/';

const userGroupDetailService = {
    fetchUserGroupDetailList(params, resolve, reject) {
        _util.request({
            url: '/api/HREmployeeWorkReportCheck/Get',
            params: params,
            success: resolve,
            error: reject
        })
    },
    addUserGroupDetailList(posts, resolve, reject) {
		_util.request({
			url: '/api/HREmployeeWorkReportCheck/Post',
			method: 'post',
			data: posts,
			success: resolve,
			error: reject
		});
	},
    updateUserGroupDetailList(puts, resolve, reject) {
		_util.request({
			url: '/api/HREmployeeWorkReportCheck/Put',
			method: 'put',
			data: puts,
			success: resolve,
			error: reject
		});		
	},
	deleteUserGroupDetailList(deletes, resolve, reject) {
		_util.request({
			url: '/api/HREmployeeWorkReportCheck/Delete',
			method: 'delete',
			data: deletes,
			success: resolve,
			error: reject
		});
	}
}



export default userGroupDetailService;


// WEBPACK FOOTER //
// ./src/services/DailyReport/user-group-detail-service.js